<template>
  <div>
    <!-- eslint-disable-next-line vue/no-v-for-template-key -- Baseline eslint ignore please fix if working on this-->
    <template v-for="compliance in compliances" :key="compliance.name">
      <CompanyAddressCompanyAlert v-if="compliance.name === 'COMPANY_ADDRESS'" />
      <template v-if="compliance.name === 'IR35'">
        <Ir35FreelancerAlert
          v-if="!compliance.data.hasAnsweredAllQuestions"
          :freelancer="activeAccount"
          :has-answered-old-questions="compliance.data.hasAnsweredOldQuestions"
          :yjob="compliance.data.yjob"
        />
        <Ir35InsuranceFreelancerAlert
          v-if="!compliance.data.hasInsurance"
          :has-answered-all-questions="compliance.data.hasAnsweredAllQuestions"
          :yjob="compliance.data.yjob"
        />
      </template>
      <UsWorkerClassificationFreelancerAlert
        v-if="compliance.name === 'US_WORKER_CLASSIFICATION'"
        :freelancer="activeAccount"
      />
      <AddressIncompleteAlert
        v-if="compliance.name === 'ADDRESS'"
        :key="compliance.name"
        :compliance-data="compliance.data"
        :hire="hire"
        :is-complete="compliance.isComplete"
      />
      <BankAccountAlert v-if="compliance.name === 'BANK_ACCOUNT'" :key="compliance.name" />
      <GlobalWorkerClassificationAlert
        v-if="compliance.name === 'GLOBAL_WORKER_CLASSIFICATION'"
        :key="compliance.name"
        :freelancer-id="activeAccount.localId"
      />
      <EmployerOfRecordAlert
        v-if="compliance.name === ComplianceName.EMPLOYER_OF_RECORD"
        :key="compliance.name"
        :compliance-data="compliance.data"
      />
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import gql from 'graphql-tag'
import { useQuery } from '@vue/apollo-composable'
import CompanyAddressCompanyAlert from '@/components/compliances/alerts/CompanyAddressCompanyAlert.vue'
import Ir35FreelancerAlert, {
  fragments as Ir35FreelancerAlertAccountFragments,
} from '@/components/compliances/alerts/Ir35FreelancerAlert.vue'
import BankAccountAlert from '@/components/compliances/alerts/BankAccountAlert.vue'
import AddressIncompleteAlert from '@/components/compliances/alerts/AddressIncompleteAlert.vue'
import Ir35InsuranceFreelancerAlert from '@/components/compliances/alerts/Ir35InsuranceFreelancerAlert.vue'
import UsWorkerClassificationFreelancerAlert, {
  fragments as UsWorkerClassificationFreelancerAlertFragments,
} from '@/components/compliances/alerts/UsWorkerClassificationFreelancerAlert.vue'
import { ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT } from '@/components/compliances/queries/Compliances'
import AccountType from '@/utils/AccountType'
import { useTranslation } from '@/composables/translation'
import { ParseJSONPropertyInObject } from '@/utils/ParseJSONPropertyInObject'
import GlobalWorkerClassificationAlert from '@/components/compliances/alerts/GlobalWorkerClassificationAlert.vue'
import { ComplianceName } from '@/components/compliances/types/ComplianceName.enum'
import EmployerOfRecordAlert from '@/components/compliances/alerts/EmployerOfRecordAlert.vue'

const { $t } = useTranslation()

const complianceNames = [
  'COMPANY_ADDRESS',
  'IR35',
  'US_WORKER_CLASSIFICATION',
  'ADDRESS',
  'BANK_ACCOUNT',
  'GLOBAL_WORKER_CLASSIFICATION',
  'EMPLOYER_OF_RECORD',
]

const { result } = useQuery(
  gql`
    query accountQuery($complianceNames: [ComplianceName!]!) {
      me {
        activeAccount {
          __typename
          ...ActiveCompliancesOnAccount
          ...Ir35FreelancerAlertAccount
          ...UsWorkerClassificationFreelancerAlertAccount
        }
      }
    }
    ${ACTIVE_COMPLIANCES_ON_ACCOUNT_FRAGMENT}
    ${Ir35FreelancerAlertAccountFragments.account}
    ${UsWorkerClassificationFreelancerAlertFragments.account}
  `,
  {
    complianceNames,
  },
)

const activeAccount = computed(() => result?.value?.me?.activeAccount)
const compliances = computed(
  () =>
    activeAccount.value?.compliances
      ?.filter(({ name, isApplicable, isComplete }) => {
        if (!isApplicable) {
          return false
        }
        if (isComplete) {
          return false
        }
        if (
          name === 'IR35' ||
          name === 'US_WORKER_CLASSIFICATION' ||
          name === 'GLOBAL_WORKER_CLASSIFICATION'
        ) {
          return AccountType.isFreelancer(activeAccount.value.__typename)
        }
        return true
      })
      ?.map((compliance) => ParseJSONPropertyInObject('data', compliance)) || [],
)
</script>
